// extracted by mini-css-extract-plugin
module.exports = {"list":"list-2VwBnNJQ clearfix","listitem":"listitem-16kBl6a7","hot":"hot-qmC1QN98","box":"box-32G0RbSR","mask":"mask-LD0yOEfE","title":"title-cXqZwshp","tip":"tip-3XoWzwMH"};